import httpService from "V2.0/services/httpService";
import { showErrorToast } from "V2.0/utils";

export function useMessengerSend() {
  const sendMessengerMessage = async (
    projectId,
    assistantId,
    data,
    onSuccess
  ) => {
    const { toNumber, message } = data;
    const payload = {
      userIdentifier: toNumber,
      message,
    };
    try {
      const response = await httpService.post(
        `/messenger/manage/whitelabelAddToMessengerThread/${projectId}/${assistantId}`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onSuccess();
      }
    } catch (e) {
      showErrorToast(e, "Failed to send message");
    }
  };

  return { sendMessengerMessage };
}
